/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressKitImageListByCompanyIdResults,
    PressKitImageListByCompanyIdResultsFromJSON,
    PressKitImageListByCompanyIdResultsFromJSONTyped,
    PressKitImageListByCompanyIdResultsToJSON,
} from './PressKitImageListByCompanyIdResults';

/**
 * 企業のプレスキットの画像一覧
 * @export
 * @interface PressKitImageListByCompanyId
 */
export interface PressKitImageListByCompanyId {
    /**
     * 企業のプレスキットのロゴの総数
     * @type {number}
     * @memberof PressKitImageListByCompanyId
     */
    total: number;
    /**
     * プレスキットロゴ一覧。仕様上は最大50件。
     * @type {Array<PressKitImageListByCompanyIdResults>}
     * @memberof PressKitImageListByCompanyId
     */
    results: Array<PressKitImageListByCompanyIdResults>;
}

export function PressKitImageListByCompanyIdFromJSON(json: any): PressKitImageListByCompanyId {
    return PressKitImageListByCompanyIdFromJSONTyped(json, false);
}

export function PressKitImageListByCompanyIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressKitImageListByCompanyId {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'results': ((json['results'] as Array<any>).map(PressKitImageListByCompanyIdResultsFromJSON)),
    };
}

export function PressKitImageListByCompanyIdToJSON(value?: PressKitImageListByCompanyId | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(PressKitImageListByCompanyIdResultsToJSON)),
    };
}

